<template>
<el-config-provider :locale="locale">
  <div id="app"><router-view/></div>
</el-config-provider>
</template>

<script>
 import zhCn from 'element-plus/lib/locale/lang/zh-cn' //分页显示中文
export default {
  name: 'App',
  setup() { 
    const lang = () => {// eslint-disable-line no-unused-vars(如果运行时报错，就加上前面这行注释)
      location.reload()
    }
    
    let locale = zhCn
      return { locale };
  },
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #f5f7fa;
}

/* 全局的滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
  height: 9px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #909399;
}

/* Element Plus 基础样式覆盖 */
:root {
  --el-color-primary: #4170FF !important;
}

/* 卡片容器通用样式 */
.el-card {
  border-radius: 8px !important;
  overflow: hidden !important;
  transition: all 0.3s !important;
  border: 0.5px solid #EBEEF5 !important;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.05) !important;
}

.el-card:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1) !important;
  transform: translateY(-2px);
}

/* 按钮样式优化 */
.el-button {
  transition: all 0.3s !important;
}

.el-button:hover {
  transform: translateY(-2px);
}

/* 表格通用样式 */
.el-table th {
  background-color: #f6f8fa !important;
}

/* .el-popover{
  background-color: transparent !important;
  border-color:  #4170FF !important;
} */
/*
.el-popover[x-placement^="bottom"] .popper_arrow {
  border-bottom-color:#000 !important;
}
.el-popover[x-placement^="bottom"] .popper_arrow::after{
  border-bottom-color: #000 !important;
}
.el-popover .popoverBackB{
  background: #000e2b !important;
  opacity: 0.9;
}  */
</style>
